import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Http, Response, RequestOptions, HttpModule, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { configURI, configURI2 } from '../../../shared/apiUrlConfig';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs';
import { UserFriendlyMsgs } from '../../app.user-msgs';
import { environment } from '../../../environments/environment';

@Injectable()
export class AgentEmployeeService {
  load;
  url = environment.configURI;
  loginId;
  private typeOfEmpDocsURL = "/documents/GetDocumentTypesByCategory?Category=AGENTEMPLOYEE";
  private getByEmolyeeID = "/agentemployee/getagentemployeebyempid?employee_id=";
  vendor_id: any;
  constructor(private httpClient: HttpClient, private http: Http, private userFriendlyMsgs: UserFriendlyMsgs) {
    this.load = new BehaviorSubject('initial');
    this.vendor_id = localStorage.getItem("AgentId");
  }

  getAgentEmployees(agentId) {

    let role = parseInt(localStorage.getItem("RoleVal"))
    if (role === 8) {
      return this.httpClient.get(this.url + '/client/vendor/' + agentId + '/employee').catch(this.userFriendlyMsgs.errorHandler);
    } else {
      return this.httpClient.get(this.url + '/vendor/' + agentId + '/employee').catch(this.userFriendlyMsgs.errorHandler);
    }
  }

  addAgentEmployees(data) {
    this.vendor_id = localStorage.getItem("AgentId");
    this.loginId = localStorage.getItem('loginID');
    const body = {
      vendor_id: this.vendor_id,
      bc_check_date: data.bcDate,
      address: data.employeeAddress,
      city: data.employeeCity,
      state: data.employeeState,
      employee_type: data.employeeType,
      zip: data.employeeZip,
      first_name: data.firstName,
      last_name: data.lastName,
      middle_name: data.middleName,
      created_by: this.loginId
    }
    return this.httpClient.post(this.url + '/vendors/employee', body).catch(this.userFriendlyMsgs.errorHandler);
  }

  getagentemployeeby_id(employee_id, vendor_id) {
    let role = parseInt(localStorage.getItem("RoleVal"))
    if (role === 8) {
      return this.httpClient.get(this.url + '/client/vendors/employee/' + employee_id).catch(this.userFriendlyMsgs.errorHandler);
    } else {
      return this.httpClient.get(this.url + '/vendors/employee/' + vendor_id + '/' + employee_id).catch(this.userFriendlyMsgs.errorHandler);
    }

  }

  employeeedited(data, agentId) {
    this.loginId = localStorage.getItem('loginID');
    const body = {
      first_name: data.firstName,
      middle_name: data.middleName,
      last_name: data.lastName,
      employee_type: data.employeeType,
      bc_check_date: data.bcDate,
      address: data.employeeAddress,
      city: data.employeeCity,
      state: data.employeeState,
      zip: (data.employeeZip).toString(),
      updated_by: this.loginId
    }
    return this.httpClient.put(this.url + '/vendors/employee/' + agentId + '/' + data._id, body).catch(this.userFriendlyMsgs.errorHandler);
  }

  validateEmpDocuments(data) {
    this.loginId = localStorage.getItem('loginID');
    const body = {
      expiry_dtm: data.expiry_dtm,
      completion_dtm: data.completion_dtm,
      document_link: data.document_link,
      issue_dtm: data.issue_dtm,
      file_name: data.file_name,
      updated_by: this.loginId,
      vendor_id: data.vendor_id,
      DocumentStatus: "In Progress"
    }
    return this.httpClient.put(this.url + '/vendors/employees/document/' + data.docId, body).catch(this.userFriendlyMsgs.errorHandler);;
  }
  approveEmpDocuments(data) {
    this.loginId = localStorage.getItem('loginID');
    const body = {
      expiry_dtm: data.expiry_dtm,
      completion_dtm: data.completion_dtm,
      document_link: data.document_link,
      issue_dtm: data.issue_dtm,
      file_name: data.file_name,
      updated_by: this.loginId,
      vendor_id: data.vendor_id,
      DocumentStatus: "Approved"
    }
    return this.httpClient.put(this.url + '/vendors/employees/document/' + data.docId, body).catch(this.userFriendlyMsgs.errorHandler);;
  }

  rejectEmpDocuments(data) {
    this.loginId = localStorage.getItem('loginID');
    const body = {
      expiry_dtm: data.expiry_dtm,
      completion_dtm: data.completion_dtm,
      document_link: data.document_link,
      issue_dtm: data.issue_dtm,
      file_name: data.file_name,
      updated_by: this.loginId,
      vendor_id: data.vendor_id,
      DocumentStatus: "Rejected",
      DocumentComments: data.DocumentComments
    }
    return this.httpClient.put(this.url + '/vendors/employees/document/' + data.docId, body).catch(this.userFriendlyMsgs.errorHandler);;
  }

  deleteEmployees(data, agentId) {
    if (data.employeeData.EmployeeStatus && data.employeeData.EmployeeStatus === 'Reject') {
      let body = {
        status: data.employeeData.EmployeeStatus,
        comments: data.employeeData.Comments
      };
      /*const httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }), body
      };*/
      return this.httpClient.post(this.url + '/vendors/employee/' + agentId + '/' + data.employeeData._id, body).catch(this.userFriendlyMsgs.errorHandler);
    } else {
      return this.httpClient.post(this.url + '/vendors/employee/' + agentId + '/' + data.employeeData._id,{}).catch(this.userFriendlyMsgs.errorHandler);
    }
  }


  TypeOfEmpDocs() {
    return this.httpClient.get(this.url + this.typeOfEmpDocsURL).catch(this.userFriendlyMsgs.errorHandler);
  }

  getEmployeeListDocuments(employeeId, vendor_id) {
    let role = parseInt(localStorage.getItem("RoleVal"))
    if (role === 8) {
      return this.httpClient.get(this.url + '/client/vendors/employee/all/' + employeeId).catch(this.userFriendlyMsgs.errorHandler);
    } else {
      return this.httpClient.get(this.url + '/vendors/employee/all/' + vendor_id + '/' + employeeId).catch(this.userFriendlyMsgs.errorHandler);
    }
  }

  submitDocumentVal(body) {
    return this.httpClient.post(this.url + '/vendors/employees/documents', body).catch(this.userFriendlyMsgs.errorHandler);;
  }

  updateEmpDocuments(data) {
    this.loginId = localStorage.getItem('loginID');
    const body = {
      expiry_dtm: data.expiry_dtm,
      completion_dtm: data.completion_dtm,
      document_link: data.document_link,
      issue_dtm: data.issue_dtm,
      file_name: data.file_name,
      updated_by: this.loginId,
      vendor_id: data.vendor_id,
      DocumentStatus:"Approved",
      fileUpdated: data.fileUpdated
    }
    return this.httpClient.put(this.url + '/vendors/employees/document/' + data.docId, body).catch(this.userFriendlyMsgs.errorHandler);;
  }

  deleteEmpDocuments(data) {
    return this.httpClient.delete(this.url + '/vendors/employees/document/' + this.vendor_id + '/' + data._id).catch(this.userFriendlyMsgs.errorHandler);;
  }

  getByAgentEmployeeID(id) {
    return this.httpClient.get(`${this.url}${this.getByEmolyeeID}${id}`).catch(this.userFriendlyMsgs.errorHandler);;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/agent-employee/agent-employee.service.ts